import { noop } from 'lodash';
import { useHistory } from 'react-router';

import { Form, useForm } from '@shared/forms/components/Form';
import { TextField } from '@shared/forms/components/TextField';
import { Portlet } from '@shared/ui/components/Portlet';
import { getVenue } from '@shared/venues/endpoints/getVenue';
import { updateVenue } from '@shared/venues/endpoints/updateVenue';

import { AdminWrapper } from '@admin/layout/components/AdminWrapper';

type VenueData = App.Domain.Event.Data.VenueData;

export function EditVenue({ match }: any) {
  const { push } = useHistory();

  const { form, fields } = useForm<VenueData>({
    source: {
      id: match.params.id,
      provider: getVenue,
    },
  });

  const venueId: number = match.params.id;

  return (
    <AdminWrapper title="Edit Venue" breadcrumb={{ label: 'Venues', url: '/admin/new-venues' }}>
      <Portlet>
        <Form
          action={(data) => updateVenue({ id: venueId }, data)}
          onSave={noop}
          onSaveAndReturn={() => push('/admin/new-venues')}
          onCancel={() => push('/admin/new-venues')}
          form={form}
        >
          <TextField name={fields.name} label="Name" />
        </Form>
      </Portlet>
    </AdminWrapper>
  );
}
